import { Error, makeAutoObservable, reaction, SDK, set } from 'sdk';

export class ModalStore {
	constructor(sdk: SDK) {
		makeAutoObservable(this);

		reaction(
			() => sdk.videoCallsStore.errors.length,
			(v) => {
				if (v > 0) {
					this.errors.push(...sdk.videoCallsStore.errors);
					sdk.videoCallsStore.clearErrors();
				}
			}
		);

		reaction(
			() => sdk.screenCaptureStore.errors.length,
			(v) => {
				if (v > 0) {
					this.errors.push(...sdk.screenCaptureStore.errors);
					sdk.screenCaptureStore.clearErrors();
				}
			}
		);
	}

	private errors: Error[] = [];

	push = (error: Error): void => set(this.errors, [...this.errors, error]);

	get len(): number {
		return this.errors.length;
	}

	pop(): Error | undefined {
		return this.errors.shift();
	}
}
